module.exports = __webpack_public_path__ + "img/t5-c2.8059425a.png";